var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "ok-disabled": _vm.isLoading },
      on: { ok: _vm.submitData },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.button.cancel")) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.paymentMethod !== "promptpay"
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "info",
                        disabled: !_vm.paymentMethod || _vm.isLoading
                      },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.isLoading
                              ? _vm.$t("message.button.loading")
                              : _vm.$t("message.button.ok")
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e()
            ]
          }
        }
      ]),
      model: {
        value: _vm.status,
        callback: function($$v) {
          _vm.status = $$v
        },
        expression: "status"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("message.my_reservations.book_additional_ironing_service")
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass:
              "row no-gutters d-flex align-items-center justify-content-center"
          },
          [
            _c("div", { staticClass: "col-8" }, [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.booking.booking_step.cloth_qty")) + ":"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(
                  "b-input-group",
                  [
                    _c(
                      "b-input-group-prepend",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "info" },
                            on: {
                              click: function($event) {
                                return _vm.decreaseAmount()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-minus" })]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "text-center",
                      model: {
                        value: _vm.purchaseQty,
                        callback: function($$v) {
                          _vm.purchaseQty = $$v
                        },
                        expression: "purchaseQty"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "info" },
                            on: {
                              click: function($event) {
                                return _vm.increaseAmount()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-plus" })]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.subtotal
        ? _c("section", [
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row text-remark" }, [
              _c("div", { staticClass: "col-6 p-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.my_reservations.summary_total.subtotal")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 p-0 text-right" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("currency")(_vm.subtotal)) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row text-remark mt-1" }, [
              _c("div", { staticClass: "col-6 p-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "message.my_reservations.summary_total.service_vat"
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 p-0 text-right" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("currency")(
                        _vm.subtotal * _vm.globalState.serviceVat
                      )
                    ) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-1" }, [
              _c("div", { staticClass: "col-6 p-0" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.my_reservations.summary_total.total")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 p-0 text-right" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.subtotal + _vm.subtotal * _vm.globalState.serviceVat
                      )
                    )
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", [
        _c("hr"),
        _vm._v(" "),
        _c("label", [
          _vm._v(_vm._s(_vm.$t("message.booking.checkout_step.payment_method")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card shadow-sm" }, [
          _c(
            "div",
            { staticClass: "card-body p-3" },
            [
              _c("div", { staticClass: "exp" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.paymentMethod,
                        expression: "paymentMethod"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      id: "paymentCreditDebit",
                      name: "paymentMethod",
                      value: "credit_card"
                    },
                    domProps: {
                      checked: _vm._q(_vm.paymentMethod, "credit_card")
                    },
                    on: {
                      change: function($event) {
                        _vm.paymentMethod = "credit_card"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "mb-0",
                      attrs: { for: "paymentCreditDebit" }
                    },
                    [
                      _c("span"),
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.payment_step.pay_by_credit_debit_card"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.payment
                ? [
                    _vm.paymentMethod === "credit_card"
                      ? _c(
                          "div",
                          { staticClass: "payment-method" },
                          [
                            _c("payment-small", {
                              attrs: { payment: _vm.payment }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.payment === null ? [_c("loader")] : _vm._e()
                  ]
                : [
                    _vm.paymentMethod === "credit_card"
                      ? _c(
                          "div",
                          { staticClass: "mt-3" },
                          [
                            _c("payment-form", {
                              ref: "paymentForm",
                              attrs: { paymentData: _vm.paymentData }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card shadow-sm" }, [
          _c("div", { staticClass: "card-body p-3" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.paymentMethod,
                      expression: "paymentMethod"
                    }
                  ],
                  ref: "bankTransfer",
                  attrs: {
                    type: "radio",
                    id: "bankTransfer",
                    name: "paymentMethod",
                    value: "bank_transfer"
                  },
                  domProps: {
                    checked: _vm._q(_vm.paymentMethod, "bank_transfer")
                  },
                  on: {
                    change: function($event) {
                      _vm.paymentMethod = "bank_transfer"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "bankTransfer" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "message.booking.payment_step.pay_by_bank_transfer"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.paymentMethod === "bank_transfer"
              ? _c("div", { staticClass: "payment-method" }, [
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-12 p-0" }, [
                      _c("div", [
                        _c("div", [
                          _c("img", {
                            staticClass: "mb-2",
                            attrs: {
                              src: _vm.globalState.bankAccountData.image_url,
                              width: "160"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.bank_transfer.account_name")
                            ) +
                              ": " +
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.globalState.bankAccountData
                                )
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-center"
                          },
                          [
                            _c("div", { staticClass: "flex-grow-1" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.bank_transfer.account")
                                  ) +
                                    ": " +
                                    _vm._s(
                                      _vm.globalState.bankAccountData
                                        .account_number
                                    )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-right" }, [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:copy",
                                      value:
                                        _vm.globalState.bankAccountData
                                          .account_number,
                                      expression:
                                        "globalState.bankAccountData.account_number",
                                      arg: "copy"
                                    }
                                  ],
                                  staticClass: "btn btn-outline-info",
                                  on: {
                                    click: function($event) {
                                      _vm.isCopied = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.isCopied
                                          ? _vm.$t("message.button.copied")
                                          : _vm.$t("message.button.copy")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "message.bank_transfer.attach_transfer_picture"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("vue-dropzone", {
                            ref: "vueDropzone",
                            staticClass: "dropzone-dashed",
                            attrs: {
                              id: "dropzone",
                              options: _vm.dropzoneOptions
                            },
                            on: {
                              "vdropzone-file-added": _vm.handleFileUpload,
                              "vdropzone-max-files-exceeded":
                                _vm.vueDropZoneMaxFilesExceeded
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-remark py-2" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t(
                                    "message.bank_transfer.transfer_picture_remark01"
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card shadow-sm" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.globalState.configData.promptpay.status === 1
              ? _c("div", { staticClass: "exp" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paymentMethod,
                          expression: "paymentMethod"
                        }
                      ],
                      ref: "promptpay",
                      attrs: {
                        type: "radio",
                        id: "promptpay",
                        name: "paymentMethod",
                        value: "promptpay"
                      },
                      domProps: {
                        checked: _vm._q(_vm.paymentMethod, "promptpay")
                      },
                      on: {
                        change: function($event) {
                          _vm.paymentMethod = "promptpay"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "mb-0", attrs: { for: "promptpay" } },
                      [
                        _c("span"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.payment_step.pay_by_promptpay"
                              )
                            ) +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "rounded ml-2",
                          attrs: {
                            src: "/static/img/thai_qr_payment.png",
                            width: "90"
                          }
                        })
                      ]
                    )
                  ])
                ])
              : _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start"
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass: "fas fa-circle fa-lg -status-offline"
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pl-3" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.payment_step.pay_by_promptpay"
                              )
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          staticClass: "rounded ml-2",
                          attrs: {
                            src: "/static/img/thai_qr_payment.png",
                            width: "90"
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-3 text-small" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$i18n.locale === "th"
                            ? _vm.globalState.configData.promptpay.remark_th
                            : _vm.globalState.configData.promptpay.remark_en
                        ) +
                        "\n          "
                    )
                  ])
                ])
          ])
        ]),
        _vm._v(" "),
        _vm.paymentMethod === "promptpay"
          ? _c(
              "div",
              { staticClass: "pt-4" },
              [
                _c("qr-code-payment", {
                  ref: "qrCodePayment",
                  on: { checkQrPayment: _vm.checkQrPayment }
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "text-remark" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.promptpay.payment_remark")) +
                      "\n      "
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7924421e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7924421e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/PurchaseServiceModal.vue
// module id = 1771
// module chunks = 0